/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_SELECTED](state, { swatch, sticker, componentName }) {
    state.selectedSwatch = {
      ...state.selectedSwatch,
      [componentName]: swatch
    };
    state.selectedSticker = {
      ...state.selectedSticker,
      [componentName]: sticker
    };
  },
  [types.RESET_SELECTED](state, componentName) {
    state.selectedSwatch = {
      ...state.selectedSwatch,
      [componentName]: null
    };
    state.selectedSticker = {
      ...state.selectedSticker,
      [componentName]: null
    };
  },
  [types.SET_PATTERN](state, { data, componentName }) {
    state.currentPattern = {
      ...state.currentPattern,
      [componentName]: data
    };
  },
  [types.RESET_PATTERN](state, componentName) {
    state.currentPattern = {
      ...state.currentPattern,
      [componentName]: null
    };
  },
  [types.SET_ORDER_STYLES](state, data) {
    state.orderStyles = data;
  },
  [types.SET_SELECTED_STYLE](state, style) {
    state.selectedStyle = style;
  },
  [types.SET_IS_CREATING_ASSETS](state, isCreatingAssets) {
    state.isCreatingAssets = isCreatingAssets;
  },
  [types.SET_VIEWS](state, views) {
    state.navigation.views = views;
  },
  [types.SET_ACTIVE_VIEW](state, activeView) {
    const index = state.navigation.views.indexOf(activeView);
    if (index < 0) {
      throw new Error(`Invalid view: ${activeView}`);
    }
    state.navigation.activeViewIndex = index;
    state.navigation.activeView = activeView;
  },
  [types.PREV_VIEW](state) {
    const index = state.navigation.activeViewIndex - 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    const activeView= state.navigation.views[index];
    this.commit("patternMaker/SET_ACTIVE_VIEW", activeView);
  },
  [types.NEXT_VIEW](state) {
    const index = state.navigation.activeViewIndex + 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    const activeView= state.navigation.views[index];
    this.commit("patternMaker/SET_ACTIVE_VIEW", activeView);
  },
  [types.SET_SELECTABLE_MODELS_DATA](state, data) {
    state.selectableStyles = data;
  },

  [types.UPDATE_PREVIEW_IMAGE](state, data) {
    state.previewImage = {
      ...state.previewImage,
      ...data,
    };
  },

  [types.SET_ACTIVE_UGC_COMPONENT](state, activeUGCComponent) {
    state.activeUGCComponent = activeUGCComponent;
  },

  [types.SET_HIGHLIGHT_SELECT_SWATCH_INSTRUCTIONS](state, highlight) {
    state.highligthSelectSwatchInstructions = highlight;
  },
  [types.SET_HIGHLIGHT_SELECT_STICKER_INSTRUCTIONS](state, highlight) {
    state.highligthSelectStickerInstructions = highlight;
  },
  [types.USE_SVG_RENDERER](state, payload ) {
    state.useSvgRenderer = payload;
  },
  [types.SET_SOURCE](state, { source = '' }) {
    state.source = source;
  },
};

export default mutations;
